<template>
  <div class="employee_page" :style="{'background-image': 'url('+previewUrl+')'}">
    <van-image
      width="300"
      height="auto"
      :src="QRCodeUrl"
      class="auto"
    />
  </div>
</template>

<script>
import { getLandingPageApi, getQRCodeApi, getPreviewUrlApi } from '@/api/employeePage'

export default {
  data () {
    return {
      previewUrl: '',
      QRCodeUrl: ''
    }
  },
  created () {
    this.getLandingPage()
    this.getQRCode()
  },
  methods: {
    // 落地页
    getLandingPage () {
      getLandingPageApi({ channelId: this.$route.query.channelId }).then((res) => {
        if (res.success) {
          this.getPreviewUrl(res.data.picUrl)
        } else {
          this.$toast(res.msg)
        }
      }).catch((err) => {
        this.$toast('网络错误')
      })
    },
    // 预览地址
    getPreviewUrl (url) {
      if (!url) {
        return
      }
      getPreviewUrlApi({ key: url }).then((res) => {
        if (res.success) {
          this.previewUrl = res.data
        } else {
          this.$toast(res.msg)
        }
      }).catch((err) => {
        this.$toast('网络错误')
      })
    },
    // 二维码
    getQRCode () {
      getQRCodeApi({ id: this.$route.query.channelId }).then((res) => {
        if (!res) {
          return
        }
        const blob = new Blob([res], {type: 'image/jpeg'})
        this.QRCodeUrl = window.URL.createObjectURL(blob)
      }).catch((err) => {
        this.$toast('网络错误')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.employee_page {
  height: 100%;
  padding-top: 200px;
  box-sizing: border-box;
  text-align: center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: top;
}
</style>